import { showToast } from "../../components/InfoToast";
import { ACHIEVEMENTS_DATA_KEY, ACHIEVEMENTS_STATE, EDITOR_VIEW_NAME, QUESTION_MODAL_STATE } from "../../core/constants";
import { translate } from "../../core/i18n";
import { getDomainCfg } from "../../core/state";
import { getComponentData, getViewData, setComponentData } from "../../core/views";
import { isUserLoggedIn } from "../cloudstorage/cloud";
import { evaluateAchievements, getAchievements, logEvent } from "./gamificationclient";
import { AchievementResponse } from "./types";

export const logGamificationEvent = async (eventType: string, name: string, optionalText: string) => {
  const enabled = getDomainCfg().viewSettings.features.gamificationEnabled && isUserLoggedIn();
  if (!enabled) {
    return false;
  }

  const event = {
    type: eventType,
    timestamp: new Date().toISOString(),
    name,
    optionalText
  };
  const success = await logEvent(event);

  if (success) {    
    await refreshAchievements();
  } else {
    console.log("Fehler beim Loggen des Events:", event);
  }
}

const refreshAchievements = async () => {
  const newAchievementIds = await evaluateAchievements();
  const hasNew = newAchievementIds.length > 0;
  await updateLocalAchievements(hasNew);
  if (hasNew) {
    const newAchievements = getAchievementsByIds(newAchievementIds);
    console.log("newAchievements!", newAchievements);
    showNewAchievements(newAchievements);
  }  
}

export const getAchievementsByIds = (ids : number[]) => {
  const achievementState = getComponentData(ACHIEVEMENTS_STATE);
  const achievements = achievementState.data?.achievements;
  if (achievements == null) {
    return [];
  }

  return achievements.filter((a) => ids.indexOf(a.id) > -1);
}

const showNewAchievements = (newAchievements : AchievementResponse[]) => {
  const editorState = getViewData(EDITOR_VIEW_NAME);  
  const modalState = getComponentData(QUESTION_MODAL_STATE);

  const successModalShown = editorState.cfg?.editorFeatures?.showSuccessModal && modalState.data?.show === true;
  if (successModalShown) {
    showAchievementsInSuccessModal(newAchievements);
  } else {
    showAchievementsToast(newAchievements);
  }
} 

const showAchievementsToast = (newAchievements : AchievementResponse[]) => {
  console.log("showAchievementsToast", newAchievements);  
  //loop through all new achievements and show toast after delay of 3s
  for (let i = 0; i < newAchievements.length; i++) {
    const achievement = newAchievements[i];
    setTimeout(() => {
      const title = achievement.name;
      const message = achievement.description;
      showToast(title, message);
    }, (5000 * i) + 500);
  }
}

const showAchievementsInSuccessModal = (newAchievements : AchievementResponse[]) => {
  const modalState = getComponentData(QUESTION_MODAL_STATE);
  let achievementsText = `<hr>${translate('achievement-unlocked')} <br><div><ul>`
  for (let i = 0; i < newAchievements.length; i++) {
    const achievement = newAchievements[i];
    const title = achievement.name;
    const message = achievement.description;
    achievementsText += `<li><b>${title}</b>: ${message}</li>`;
  }
  achievementsText += '</ul></div>';
  const newModalState = {
    ...modalState,
    data: {
      ...modalState.data,
      children: modalState.data.children + achievementsText  
    }
    
  }
  console.log("showAchievementsInModal", newAchievements, newModalState);  
  setComponentData(QUESTION_MODAL_STATE, newModalState);
}

export const updateLocalAchievements = async (refreshLocal) => {
  if (!getDomainCfg().viewSettings.features.gamificationEnabled) {
    return;
  }
  
  const hasLocal = loadAchievementsFromLS();
  if (hasLocal && !refreshLocal) {
    return;
  }

  if (!isUserLoggedIn()) {
    return;
  }

  const achievements = await getAchievements(); 
  saveAchievementsToLS(achievements);  
}

export const loadAchievementsFromLS = () : boolean => {    
  const achievementsJson = localStorage.getItem(ACHIEVEMENTS_DATA_KEY);
  if (achievementsJson == null) {
    return false;
  }

  const achievementsData = JSON.parse(achievementsJson);
  const achievementState = getComponentData(ACHIEVEMENTS_STATE);
  //if (achievementState.data?.achievements !== undefined) return true;

  const newAchievementsState = {
    ...achievementState,
    data : {
      achievements : achievementsData
    }
  };
  
  setComponentData(ACHIEVEMENTS_STATE, newAchievementsState);
  return true;
}

export function saveAchievementsToLS(achievements : any) {
    if (achievements == null) {
      return;
    }
  
    const achievementsJson = JSON.stringify(achievements);
    localStorage.setItem(ACHIEVEMENTS_DATA_KEY, achievementsJson);
    loadAchievementsFromLS();
}

export function removeAchievementsFromLS() {
  localStorage.removeItem(ACHIEVEMENTS_DATA_KEY);
}
